import Swiper from "swiper/bundle";
import MicroModal from "micromodal";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import Opening from "./class/Opening";
import Top from "./class/Top";
import Video from "./class/Video";
import { Share } from "./utils/Share";
import { SmoothScroll } from "./utils/SmoothScroll";
import Hamburger from "./class/Hamburger";
import Accordion from "./class/Accordion";
import Modal from "./class/Modal";

class Main {
  constructor() {
    Share();
    new Hamburger(".l-header__menu", "is-open");
    new Accordion();
    new Modal(MicroModal);

    new Top(gsap, ScrollTrigger, Swiper);
    SmoothScroll();
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new Video();
  new Main();
});

window.addEventListener("load", () => {
  const headerHeight = document.querySelector("header")?.clientHeight;
  if (headerHeight) {
    document.documentElement.style.setProperty("--headerHeight", `${headerHeight}px`);
  }
  new Opening(gsap);
});

window.onload = function () {};

window.addEventListener("resize", () => {
  ScrollTrigger.refresh();
});
/*
 * スクロールバー 幅
 */
const setScrollbarWidth = () => {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty("--scrollbar", `${scrollbarWidth}px`);
};

window.addEventListener("load", setScrollbarWidth);
window.addEventListener("resize", setScrollbarWidth);
